module.exports = __webpack_public_path__ + "img/arch1.fa1c6fa7.svg";